import { render, staticRenderFns } from "./nutritionLibraryAdd.vue?vue&type=template&id=bfcea2e2&scoped=true&"
import script from "./nutritionLibraryAdd.vue?vue&type=script&lang=js&"
export * from "./nutritionLibraryAdd.vue?vue&type=script&lang=js&"
import style0 from "./nutritionLibraryAdd.vue?vue&type=style&index=0&id=bfcea2e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcea2e2",
  null
  
)

export default component.exports